import { Component, OnInit, inject } from "@angular/core";
import { CareplusAgencyService } from "src/services/careplus-agency-service";
import { PaymentLog } from "src/models/careplus-payment-log";
import { Location } from "@angular/common";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { PaymentLogDetailComponent } from "../payment-log-detail/payment-log-detail.component";

@Component({
  selector: "app-employee-payment-log",
  templateUrl: "./employee-payment-log.component.html",
  styleUrls: ["./employee-payment-log.component.css"],
})
export class EmployeePaymentLogComponent implements OnInit {
  private _careplusAgencyService = inject(CareplusAgencyService);
  private location = inject(Location);
  private _dialog = inject(MatDialog);

  paymentMode: string = "BANK_TRANSFER";
  logs: PaymentLog[] = [];
  loading: boolean = false;
  show = false;
  displayedColumns: string[] = [
    "id",
    "submissionDate",
    "bankName",
    "bankTransferReference",
    "chequeNo",
    "paymentId",
    "amount",
    "status",
    "actions",
  ];

  ngOnInit(): void {
    this.getLogs("BANK_TRANSFER");
  }

  getLogs(mode: string) {
    this.paymentMode = mode;
    this.loading = true;

    this.setDisplayedColumns();

    this._careplusAgencyService.getPayemntLog(mode).subscribe({
      next: (res: any) => {
        this.logs = Array.isArray(res) ? res : [res];
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  setDisplayedColumns() {
    const baseColumns = [
      "id",
      "submissionDate",
      "bankName",
      "paymentId",
      "amount",
      "status",
      "actions",
    ];

    if (this.paymentMode === "BANK_TRANSFER") {
      this.displayedColumns = [
        ...baseColumns.slice(0, 3),
        "bankTransferReference",
        ...baseColumns.slice(3),
      ];
    } else if (this.paymentMode === "CHEQUE_TRANSFER") {
      this.displayedColumns = [
        ...baseColumns.slice(0, 3),
        "chequeNo",
        ...baseColumns.slice(3),
      ];
    } else {
      this.displayedColumns = baseColumns;
    }
  }

  openEmployee(element: PaymentLog) {
    this._dialog.open(PaymentLogDetailComponent, {
      width: "80%",
      maxWidth: "90vw",
      height: "auto",
      data: { batchId: element.id },
      panelClass: "custom-dialog-container",
    });
  }

  back() {
    this.location.back();
  }

  getStatusLabel(status: string): string {
    if (status === "ISSUED") {
      return "Paid";
    } else {
      return "Processing";
    }
  }
}
